






import Vue from 'vue'
import props from './props'
import style from './style.module.scss'

import buttonCommon from './button.vue'

export default Vue.extend({
    name: 'button-white-no-border',
    components: {
        buttonCommon
    },
    props: {
       ...props as PropsObject
    },
    data() {
        return {
            style: style
        }
    },
})
